<script setup lang="ts">
import InpostPayButton from "~~/app/components/inpostpay/InpostPayButton.vue";

defineProps<{
  total: number;
}>();

const { formatPrice } = useMoney();
</script>

<template>
  <div class="cart-checkout-float">
    <div class="cart-checkout-float__inner">
      <NuxtLink to="/checkout" class="cart-checkout-float__btn">
        <span class="cart-checkout-float__label">
          <span class="cart-checkout-float__price">{{ formatPrice(total) }}</span>
          <span class="cart-checkout-float__separator" aria-hidden="true">-</span>
          <span>Przejdź do kasy</span>
        </span>
      </NuxtLink>
      <ClientOnly>
        <InpostPayButton context="cart" />
      </ClientOnly>
    </div>
  </div>
</template>

<style scoped>
.cart-checkout-float {
  background: var(--color-white);
  border-top: 1px solid var(--color-border);
}

.cart-checkout-float__inner {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  padding-bottom: max(12px, env(safe-area-inset-bottom));
}

.cart-checkout-float__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  gap: 10px;
  background: var(--color-black);
  color: var(--color-white);
  border: 1px solid var(--color-black);
  border-radius: var(--btn-pill-radius);
  font-family: var(--font-body);
  font-size: 0.875rem;
  font-weight: var(--font-weight-normal);
  letter-spacing: 0.04em;
  text-decoration: none;
  transition:
    background var(--transition-fast),
    color var(--transition-fast),
    border-color var(--transition-fast);
}

.cart-checkout-float__btn:hover {
  background: var(--color-white);
  color: var(--color-black);
}

.cart-checkout-float__label {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
}

.cart-checkout-float__price {
  font-weight: var(--font-weight-bold);
}

.cart-checkout-float__separator {
  opacity: 0.7;
}
</style>
